<header *ngIf="cancellationToken">
  <nav class="navbar navbar-expand-lg navbar-light"
  [style.background-color]="(dmvStoreService.cancellationTokengData$ | async)?.bannerBackgroudColor||'#006496'">
  <a >
    <div style="display: flex">
    <div [ngStyle]="{'width':(dmvStoreService.cancellationTokengData$ | async)?.megLogoWidth+'px'}">
      <img 
      src="{{globalService.staticResourceURL}}assets/images/{{(headerImageType$  | async)}}"
      class="img-fluid logo-first" aria-label="car icon"></div>&nbsp;<img 
      src="{{globalService.staticResourceURL}}assets/images/Icon-logo-white-small.svg" class="img-fluid logo-second"  style="margin-top: 8px;" aria-label="myeasygov logo">
    </div>
      <div  class="header-subtxt" >{{(dmvStoreService.cancellationTokengData$ | async)?.agencyName}} Tax Collector</div>
  </a>

  
</nav>
</header>
<header *ngIf="!cancellationToken">
  <nav class="navbar navbar-expand-lg navbar-light flex justify-content-between"
    [style.background-color]="(show$ |async)?(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor:'#006496'">
    <div class="col-auto col-lg-4  p-0">
    <a>
      <div style="display: flex">
      <div class="firstLogoImage"><img  (click)="gotoPage('home')"
        src="{{globalService.staticResourceURL}}assets/images/{{(headerImageType$  | async)}}"
        class="img-fluid logo-first" aria-label="car icon"></div>&nbsp;<img (click)="gotoPage('home')"
        src="{{globalService.staticResourceURL}}assets/images/Icon-logo-white-small.svg" class="img-fluid logo-second"  style="margin-top: 8px;" aria-label="myeasygov logo">
      </div>
        <div *ngIf="(show$ |async)" (click)="gotoPage('home')" class="header-subtxt" >{{(dmvStoreService.agencyConfigData$
        | async)?.agencyDmvConfig?.name}} Tax Collector</div>
    </a>
    </div>

    <div *ngIf="globalService.isAnnouncementVisible && !hideNotificationForHome && (dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.announcement?.text" class="text-center ">
      <div class=" mt-2 mt-md-0"><img  (click)="userAction('announcement')"
        src="{{globalService.staticResourceURL}}assets/images/annpouncment.svg"
        class="img-fluid logo-first mt-4 mt-md-0"  style="cursor: pointer;"></div>
      <div (click)="userAction('announcement')" class="d-none d-md-block text-white" style="cursor: pointer;">Announcement</div>
    </div>
 
    <div class="navbar-nav col-auto  col-lg-4  p-0 justify-content-end">
      <div class="headerLink-nav">
        <div *ngIf="(megStoreService.configurationsData$ | async)?.megConfig?.enableUserRegistration">
        <div class="headerLink" *ngIf="!isLogdin else logedIn">
          <a href="javascript:void(0)" (click)="registerNewUser()">Enroll as New User</a>
          <a href="javascript:void(0)" (click)="logIn()">Log In</a>
        </div>
        <ng-template #logedIn>
          <div class="headerLinkLogedIn popover__wrapper" (mouseenter)="setVisiblilityUserPopup(true)" >
            <a class="userName"  (click)="setVisiblilityUserPopup(true)">{{userStoreService?.getUserProfile()?.contactInfo?.firstName}}</a>
            <div class="popover__content usePopup" *ngIf="isUsePopupVisible">
              <div class="popover-brdr-btm">
                <span (click)="userAction('profile')" >My Profile</span>
              </div>
              <div class="popover-brdr-btm">
                <span (click)="userAction('faq')">Enrollment FAQs</span>
              </div>
              <div class="popover-brdr-btm">
                <span (click)="userAction('logout')">Log Out</span>
              </div>
            </div>

          </div>
        </ng-template>
        </div>
        <span class="menuopen" onclick="openNav()">☰</span>
      </div>
      <div id="myNav" class="overlay">
        <a href="javascript:void(0)" class="closebtn" onclick="closeNav()"> <svg-image   color="#ffffff" name="Icon-icon-close" [width]="24" [height]="24"></svg-image>
        </a>
        <div class="overlay-content">
          <div> <a href="javascript:void(0)" (click)="gotoPage('home')">Select County Tax Collector</a></div>
          <div> <a href="javascript:void(0)" [ngClass]="{'disabled':!dmvStoreService.selectedAgencyId}"
              (click)="userAction('county-landing')">Start Another Payment</a></div>
          <div> <a href="javascript:void(0)" [ngClass]="{'disabled':!dmvStoreService.selectedAgencyId}"
              (click)="gotoPage('about')">About My Tax Collector</a></div>
          <div  *ngIf="(megStoreService.configurationsData$ | async)?.megConfig?.enableUserRegistration"> <a href="javascript:void(0)" [ngClass]="{'disabled':!isLogdin}" (click)="userAction('profile')">My
              Profile</a></div>
          <div  *ngIf="(megStoreService.configurationsData$ | async)?.megConfig?.enableUserRegistration"> <a href="javascript:void(0)" (click)="userAction('faq')">Enrollment FAQs</a></div>
          <div  *ngIf="(megStoreService.configurationsData$ | async)?.megConfig?.enableUserRegistration"> <a href="javascript:void(0)" [ngClass]="{'disabled':!isLogdin}" (click)="userAction('logout')"><i
                class="fa fa-sign-out"></i>Log Out</a> </div>
        </div>
      </div>

    </div>
  </nav>
</header>
<div id="about-container" *ngIf="isAboutVisible">
  <about-component (close)="closeAbout()"></about-component>
</div>
<dmv-route-confirmation *ngIf="openConfirmModel" (removeConfirm)="removeConfirm()" [message]="logoutAction?((megStoreService.configurationsData$ | async)?.megConfig?.logoutPromptText):confirmationMessage"
  (continueConfirm)="continueConfirm()"></dmv-route-confirmation>